export class SortSnippets{
    public static SortByProperty<T>(array:T[],propertyName:keyof T,orientation:'asc'|'desc'='asc') {
        return array.sort((a, b) => {
            let nameA='';
            let nameB='';
            if(a[propertyName]!=null)
                nameA=(a[propertyName] as any).toLowerCase();
            if(b[propertyName]!=null)
                nameB=(b[propertyName] as any).toLowerCase();


            let result= nameA < nameB? -1 : nameA > nameB ? 1 : 0;
            if(orientation=='desc')
                return result*-1;
            return result;
        });
    }
}